import { render } from "./BardView.vue?vue&type=template&id=3c38b546&scoped=true"
import script from "./BardView.vue?vue&type=script&lang=js"
export * from "./BardView.vue?vue&type=script&lang=js"

import "./BardView.vue?vue&type=style&index=0&id=3c38b546&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c38b546"]])

export default __exports__